import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { noTextSelect } from '../../common/CssCommon';
import GridLayout from '../../common/GridLayout';
import ActiveLinkDialogFooter from './ActiveLinkDialogFooter';
import Dialog from '../Dialog';
import { genPWCSeating } from '../../plugin/pwc/pwcApis';
import { useGenNotificationPromise } from '../../notification/Notification';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../store/modules/dialog';
import { insertActiveLink } from '../../plugin/activeLink';
import { usePOWebofficeSDKState } from '../../../context/poWebOfficeSDKContext';

const DialogBody = styled.div`
  display: flex;
  flex-flow: column;
  width: 529px;
  padding: 24px;
  ${noTextSelect}
`;

const Padding = styled.div`
  height: 20px;
`;

const TitleWrapper = styled.div`
  height: 29px;
  font-size: 20px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
  margin-bottom: 24px;
`;

const ContentLabel = styled.div`
  width: 100%;
  height: 26px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  margin-bottom: 6px;
`;

const ContentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const InsertInput = styled.input`
  width: 100%;
  height: 44px;
  border-radius: 4px;
  border: solid 1px #c4c4c4;
  padding: 5px;
  font-size: 16px;
  box-sizing: border-box;
  &:focus {
    outline: none;
  }
`;

export default function ActiveLinkSeating({ isShow }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const poSDKContextState = usePOWebofficeSDKState();
  const notificationPromise = useGenNotificationPromise();

  const [inputs, setInputs] = useState({ grade: 0, classID: 0, studentNum: 0, lineNum: 0 });

  const onChange = (e) => {
    const { name, value } = e.target;
    setInputs({
      ...inputs,
      [name]: value
    });
  };

  const getInputForms = () => {
    const result = [];
    for (const prop in inputs) {
      result.push({ name: prop, value: inputs[prop] });
    }
    return result;
  };

  const forms = getInputForms();

  const checkValid = () => {
    if (
      inputs.grade &&
      inputs.classID &&
      inputs.studentNum &&
      inputs.lineNum &&
      Number.isInteger(parseInt(inputs.studentNum)) &&
      Number.isInteger(parseInt(inputs.lineNum))
    )
      return true;
    return false;
  };

  const onClickSubmit = () => {
    if (checkValid()) {
      genPWCSeating({
        grade: inputs.grade,
        classID: inputs.classID,
        studentNum: inputs.studentNum,
        lineNum: inputs.lineNum
      })
        .then((pwcURL) => insertActiveLink(poSDKContextState, pwcURL))
        .then(() => {
          dispatch(closeDialog());
        });
    } else {
      notificationPromise({
        title: t('Common.Notification'),
        message: t('ActiveLink.VoteErrorMessage'),
        btn: {
          confirm: {
            text: t('Common.Confirm')
          }
        },
        showCloseBtn: false
      });
    }
  };

  return (
    <Dialog isNoHeader isShow={isShow}>
      <DialogBody>
        <TitleWrapper>{t('ActiveLink.Seating')}</TitleWrapper>
        <GridLayout column={2} gap={21}>
          {forms.map((form) => (
            <ContentsWrapper>
              <ContentLabel>{t(`ActiveLink.${form.name}`)}</ContentLabel>
              <InsertInput
                name={form.name}
                value={form.value === 0 ? '' : form.value}
                onChange={onChange}
              />
            </ContentsWrapper>
          ))}
        </GridLayout>
        <Padding />
        <ActiveLinkDialogFooter onSubmit={onClickSubmit}></ActiveLinkDialogFooter>
      </DialogBody>
    </Dialog>
  );
}
